// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Spinner from '../Spinner';
import { CLS_PREFIX } from '../../constants';

import './ExtendedStatusMessage.less';

const ExtendedStatusMessage = ({ baseClassName, className, intent, image, children, loading, ...props }) => (
    <div className={`${baseClassName}__container`}>
        <div
            className={classNames(
                baseClassName,
                {
                    [`${baseClassName}--${intent}`]: intent,
                    [`${baseClassName}--loading`]: loading,
                },
                className,
            )}
            {...props}
        >
            {image ? <div className={`${baseClassName}__image`}>{image}</div> : null}
            <div className={`${baseClassName}__body`}>
                {children}
            </div>
            {loading && (
                <div className={`${baseClassName}__content-blocker`}>
                    <div className={`${baseClassName}__loader`}>
                        <Spinner className={`${baseClassName}__loader-spinner`} />
                    </div>
                </div>
            )}
        </div>
    </div>
);
ExtendedStatusMessage.propTypes = {
    image: PropTypes.any,
    /**
     * Visual intent color to apply to component.
     */
    intent: PropTypes.oneOf(['info', 'success', 'warning', 'danger']),
    children: PropTypes.node,
    /**
     * Indicate the loading state of the component.
     */
    loading: PropTypes.bool,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};
ExtendedStatusMessage.defaultProps = {
    image: null,
    intent: null,
    children: null,
    loading: false,
    className: null,
    baseClassName: `${CLS_PREFIX}extended-status-message`,
};

const ExtendedStatusMessageTitle = ({ baseClassName, className, children, ...props }) => (
    <div className={classNames(`${baseClassName}__title`, className)} {...props}>
        {children}
    </div>
);
ExtendedStatusMessageTitle.propTypes = {
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};
ExtendedStatusMessageTitle.defaultProps = {
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}extended-status-message`,
};

const ExtendedStatusMessageDescription = ({ baseClassName, className, children, ...props }) => (
    <div className={classNames(`${baseClassName}__description`, className)} {...props}>
        {children}
    </div>
);
ExtendedStatusMessageDescription.propTypes = {
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};
ExtendedStatusMessageDescription.defaultProps = {
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}extended-status-message`,
};

const ExtendedStatusMessageActions = ({ baseClassName, className, children, ...props }) => (
    <div className={classNames(`${baseClassName}__actions`, className)} {...props}>
        {children}
    </div>
);
ExtendedStatusMessageActions.propTypes = {
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};
ExtendedStatusMessageActions.defaultProps = {
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}extended-status-message`,
};

const ExtendedStatusMessageSeparator = ({ className, ...props }) => (
    <hr className={classNames(className)} {...props} />
);
ExtendedStatusMessageSeparator.propTypes = {
    /**
     * @ignore
     */
    className: PropTypes.string,
};
ExtendedStatusMessageSeparator.defaultProps = {
    className: null,
};

export default ExtendedStatusMessage;
export { ExtendedStatusMessageTitle, ExtendedStatusMessageDescription, ExtendedStatusMessageActions, ExtendedStatusMessageSeparator };



// WEBPACK FOOTER //
// ./components/ExtendedStatusMessage/ExtendedStatusMessage.js